
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import { db } from '@/main'
import mixin from '../../mixin'
import axios from 'axios'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
import AddUser from '@/components/users/DialogAddUser.vue'
import LockUser from '@/components/users/LockUser.vue'
import UnlockUser from '@/components/users/UnlockUser.vue'
import EnableUser from '@/components/users/EnableUser.vue'
import DisableUser from '@/components/users/DisableUser.vue'
import DeleteUser from '@/components/users/DeleteUser.vue'
import VueExcelXlsx from 'vue-excel-xlsx'

Vue.use(VueExcelXlsx)
@Component({
  components: {
    AddUser,
    LockUser,
    UnlockUser,
    EnableUser,
    DisableUser,
    DeleteUser
  }
})
export default class Users extends mixins(mixin) {
  newUser = {
    names: '',
    last_names: '',
    genre: 'Masculino',
    birthday: '',
    email: '',
    country: 'Colombia',
    state: 'Santander',
    city: 'Bucaramanga',
    image: '',
    occupation: '',
    premium: false,
    creation_date: ''
  }
  defaultUser = {
    names: '',
    last_names: '',
    genre: 'Masculino',
    birthday: '',
    email: '',
    country: 'Colombia',
    state: 'Santander',
    city: 'Bucaramanga',
    image: '',
    occupation: '',
    premium: false,
    creation_date: ''
  }
  users: any = []
  search = ''
  headers = [
    {
      text: '',
      value: 'image',
      sortable: false,
      width: '40px'
    },
    { text: 'Nombres', value: 'names' },
    { text: 'Apellidos', value: 'last_names' },
    { text: 'Género', value: 'genre_formatted' },
    { text: 'Email', value: 'email' },
    { text: 'País', value: 'country' },
    { text: 'Ciudad', value: 'city' },
    { text: 'Suscripción', value: 'premium_formatted' },
    {
      text: 'Fecha creación',
      value: 'creation_date_formatted',
      sort: (a, b) => this.compareCreationDates(a, b)
    },
    { text: 'Acciones', value: 'action', sortable: false }
  ]

  columnsExcel: any = []

  mounted() {
    // this.showNotification('loading')
    db.collection('users').onSnapshot(async querySnapshot => {
      querySnapshot.docChanges().forEach(change => {
        const user: any = change.doc.data()

        user['uid'] = change.doc.id

        if (user['genre'] == 'man') {
          user['genre_formatted'] = 'Masculino'
        } else if (user['genre'] == 'woman') {
          user['genre_formatted'] = 'Femenino'
        } else {
          user['genre_formatted'] = 'Otro'
        }

        if (!user['premium']) {
          user['premium_formatted'] = 'Gratuito'
        } else {
          user['premium_formatted'] = 'Premium'
        }

        user['creation_date_formatted'] = this.formateDate(user.creation_date)

        if (change.type === 'added') {
          this.users.unshift(user)
        }

        if (change.type === 'modified') {
          const index = this.users.findIndex(
            (user: any) => user.uid === change.doc.id
          )

          const userModified: any = this.users.find(
            (user: any) => user.uid === change.doc.id
          )
          if (userModified !== undefined && index !== -1) {
            //Existe
            userModified.names = change.doc.data().names
            userModified.last_names = change.doc.data().last_names
            userModified.image = change.doc.data().image
            userModified.birthday = change.doc.data().birthday
            userModified.email = change.doc.data().email
            userModified.genre = change.doc.data().genre
            userModified.occupation = change.doc.data().occupation
            userModified.country = change.doc.data().country
            userModified.state = change.doc.data().state
            userModified.city = change.doc.data().city
            userModified.creation_date = change.doc.data().creation_date
            userModified.premium = change.doc.data().premium
            userModified.customerID = change.doc.data().customerID
            userModified.genreFormatted = change.doc.data().genre_formatted
            userModified.premiumFormatted = change.doc.data().premium_formatted
            userModified.creation_date_formatted = this.formateDate(
              change.doc.data().creation_date
            )
          } else {
            this.users.unshift(user)
          }
        }

        if (change.type === 'removed') {
          const indexToDelete = this.users.findIndex(
            (user: any) => user.uid === change.doc.id
          )
          if (indexToDelete !== -1) {
            this.users.splice(indexToDelete, 1)
          }
        }
      })
      // this.showNotification('success')
    })
    this.getColumnsExcel()
  }

  formateDate(timestamp) {
    if (!timestamp) return ''
    const date = timestamp.toDate()

    const dd = String(date.getDate()).padStart(2, '0')
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const yyyy = date.getFullYear()
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')

    return `${dd}/${mm}/${yyyy}-${hh}:${min}`
  }

  compareCreationDates(a, b) {
    return this.parseCreationDate(a) - this.parseCreationDate(b)
  }

  parseCreationDate(value) {
    if (!value) return 0

    const match = /^(\d{2})\/(\d{2})\/(\d{4})-(\d{2}):(\d{2})$/.exec(value)
    if (!match) return 0

    return new Date(
      Number(match[3]),
      Number(match[2]) - 1,
      Number(match[1]),
      Number(match[4]),
      Number(match[5])
    ).getTime()
  }

  getColumnsExcel() {
    try {
      let mapToAdd
      this.headers.forEach(header => {
        if (header['value'] != 'action' && header['value'] != 'image') {
          mapToAdd = {
            label: header['text'],
            field: header['value']
          }

          this.columnsExcel.push(mapToAdd)
        }
      })
    } catch (error) {
      console.log('Error getColumnsExcel ' + error)
    }
  }

  async createUser(names, lastNames, email) {
    this.showNotification('loading')
    this.newUser.names = names
    this.newUser.last_names = lastNames
    this.newUser.email = email
    const url = URL_CLOUD_FUNCTIONS + 'createUser'
    try {
      const res = await axios.post(url, this.newUser)
      console.log(res)
      this.showNotification('success', 'Éxito', 'Usuario Creado')
      return res
    } catch (error) {
      console.log(error)
      this.showNotification(
        'fail',
        'Error',
        'OCurrió un error al crear el usuario'
      )
    }
  }
}
